
export const FontSizeRegex = new RegExp(/^text(-title)?-([0-9])?(xs|sm|md|lg|xl)$/)

export const classHasFontSize = (className?: string) => (className || "")
  .split(" ")
  .some((val) => FontSizeRegex.test(val))

// https://tailwindcss.com/docs/font-weight
export const FontWeightRegex = new RegExp(/^font-(thin|extralight|light|normal|medium|semibold|bold|extrabold|black)$/)

export const classHasFontWeight = (className?: string) => (className || "")
  .split(" ")
  .some((val) => FontWeightRegex.test(val))